import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParentChild } from '../../context/ParentChildContext';
import LoadingSpinner from '../common/LoadingSpinner';

const ParentChildSwitcher = ({ className = '', compact = false }) => {
    const { t } = useTranslation();
    const { enabled, loading, approvedChildren, selectedStudentId, selectChild } = useParentChild();

    if (!enabled) return null;
    if (loading) {
        return (
            <div className={className}>
                <LoadingSpinner size="sm" inline label={t('parent.childSwitcher.loadingChildren')} />
            </div>
        );
    }
    if (approvedChildren.length === 0) {
        return null;
    }

    const selectClass = compact
        ? 'w-full rounded-xl border border-white/30 bg-white/15 text-white text-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-white/40 [&>option]:text-gray-900'
        : 'input max-w-md';

    const labelClass = compact
        ? 'text-xs font-medium text-indigo-100 shrink-0'
        : 'text-sm font-medium text-gray-700 shrink-0';

    return (
        <div className={`flex flex-col sm:flex-row sm:items-center gap-2 ${className}`}>
            {!compact && (
                <label htmlFor="parent-child-select" className={labelClass}>
                    {t('parent.childSwitcher.viewingChild')}
                </label>
            )}
            {compact && approvedChildren.length > 1 && (
                <label htmlFor="parent-child-select" className={labelClass}>
                    {t('parent.childSwitcher.switchChild')}
                </label>
            )}
            <select
                id="parent-child-select"
                className={selectClass}
                value={selectedStudentId ?? ''}
                onChange={(e) => {
                    const v = e.target.value;
                    selectChild(v ? Number(v) : null);
                }}
            >
                {approvedChildren.length > 1 && (
                    <option value="">{t('parent.childSwitcher.selectChild')}</option>
                )}
                {approvedChildren.map((c) => (
                    <option key={c.studentId} value={c.studentId}>
                        {c.studentName}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default ParentChildSwitcher;
